import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";

export default function Layout() {
  useLenis();
  return (
    <div className="rp-grain min-h-screen bg-rp-bg text-white">
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(16,229,106,0.3)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}
